import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getGallections, getIsReduxModuleReady } from '../redux/selectors';
import { fetchGroupGallections } from '../redux/actions';
import { Props } from './GroupGallectionPopover';

type StateProps = Pick<Props, 'gallections' | 'isReduxReady'>;
type DispatchProps = Pick<Props, 'fetchGallections'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  ownprops
) => ({
  gallections: getGallections(
    state,
    ownprops.group.userId,
    ownprops.gallectionType
  ),
  isReduxReady: getIsReduxModuleReady(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  fetchGallections: fetchGroupGallections,
};

export default connect(mapStateToProps, mapDispatchToProps);
